import React, {ReactNode} from 'react';
import {NavLink} from 'react-router-dom';
import I18n from 'app/i18n';
import {getLinkPath} from 'app/utils';
import openHelpDeskSupport from 'app/utils/openHelpDeskSupport';

interface DisabledCountryMessageProps {
    className?: string
    compact?: boolean
}

const stopPropagation = (event: React.MouseEvent): void => {
    event.stopPropagation();
};

const handleOnlineSupportClick = (event: React.MouseEvent): void => {
    event.stopPropagation();
    openHelpDeskSupport();
};

const DisabledCountryMessage = ({className, compact = false}: DisabledCountryMessageProps): ReactNode => {
    const lineBreak = compact ? <br/> : <><br/><br/></>;

    return <div className={className}>
        {I18n.t('disabled_country.head')}{lineBreak}
        {I18n.t('disabled_country.body_1')}
        <NavLink to={getLinkPath('/faq/play_money')} onClick={stopPropagation}>{I18n.t('user_playmoney')}</NavLink>
        {I18n.t('disabled_country.body_2')}{lineBreak}
        {I18n.t('disabled_country.body_3')}
        <a className="cursor-pointer" onClick={handleOnlineSupportClick}>{I18n.t('disabled_country.online_support')}</a>
        {I18n.t('disabled_country.body_4')}
        <a href="mailto:support@egb.com" onClick={stopPropagation}>support@egb.com</a>
        {I18n.t('disabled_country.body_5')}
    </div>;
};

export default DisabledCountryMessage;
